'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  // address lookup
  ADDRESS_LOOKUP: '@@form/address-lookup/SEARCH',
  ADDRESS_RETRIEVE: '@@form/address-lookup/RETRIEVE',
  RESET_ADDRESS_LOOKUP: '@@form/address-lookup/RESET',
  INITIALISE_ADDRESS_LOOKUP: '@@form/address-lookup/INITIALISE',
  SET_ADDRESS_VIEW: '@@form/address-lookup/SET_ADDRESS_VIEW',
  // active field
  SET_ACTIVE_FIELD: '@@form/active-field/SET',
  RESET_ACTIVE_FIELD: '@@form/active-field/RESET',
  // create form state slice
  INITIALISE_FORM: '@@form/INITIALISE',
  // employment lookup
  FETCH_OCCUPATIONS: '@@form/employment-lookup/FETCH_OCCUPATIONS',
  FETCH_INDUSTRIES: '@@form/employment-lookup/FETCH_INDUSTRIES',
  CLEAR_OCCUPATIONS: '@@form/employment-lookup/CLEAR_OCCUPATIONS',
  CLEAR_INDUSTRIES: '@@form/employment-lookup/CLEAR_INDUSTRIES',
  // introducer select
  FETCH_ADVERTISERS: '@@form/introducer-lookup/FETCH_ADVERTISERS',
  FETCH_INSTRUCTORS: '@@form/introducer-lookup/FETCH_INSTRUCTORS',
  CLEAR_INSTRUCTORS: '@@form/introducer-lookup/CLEAR_INSTRUCTORS',
  // submission
  SUBMITTING_FORM: '@@form/SUBMITTING',
  SUBMITTED_FORM: '@@form/SUBMITTED',
  // update fields
  SET_VALUE: '@@form/SET_VALUE',
  SET_VALUES: '@@form/SET_VALUES',
  RESET_FIELDS: '@@form/RESET_FIELDS',
  // update form
  POPULATE_FORM: '@@form/POPULATE',
  RESET_FORM: '@@form/RESET',
  // validation
  VALIDATE_FIELD: '@@form/VALIDATE_FIELD',
  VALIDATING_FIELD: '@@form/VALIDATING_FIELD',
  VALIDATE_FORM: '@@form/VALIDATE',
  // vehicle lookup
  RESET_VEHICLE_LOOKUP: '@@form/vehicle-lookup/RESET',
  SET_MANUAL_VIEW: '@@form/vehicle-lookup/SET_MANUAL_VIEW',
  SELECT_VEHICLE: '@@form/vehicle-lookup/SELECT',
  REG_LOOKUP: '@@form/vehicle-lookup/REG_LOOKUP',
  MANUAL_LOOKUP: '@@form/vehicle-lookup/MANUAL_LOOKUP',
  CLEAR_MANUAL_LOOKUP_OPTIONS: '@@form/vehicle-lookup/CLEAR_MANUAL_LOOKUP_OPTIONS',
  SEARCHABLE_LIST_CHANGE_QUERY: '@@form/searchable-list/CHANGE_QUERY',
  SEARCHABLE_LIST_FETCH: '@@form/searchable-list/FETCH',
  SEARCHABLE_LIST_CLEAR: '@@form/searchable-list/CLEAR',
  // snapshot
  CREATE_SNAPSHOT: '@@form/CREATE_SNAPSHOT'
};